import assetPath from '/app/packages/lebenslauf/articles/src/assets/ausserordentlich.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')